import { useCallback } from 'react';

import { postRequest } from '../../services/api';

const INTERACTION_MARKERS = new Set([
  'idCheck.onStepInitiated',
  'idCheck.onStepCompleted',
  'idCheck.onApplicantSubmitted',
]);

export function useKycInteractionReport(isHidden?: boolean) {
  const shouldReport = !isHidden;

  const handleSumSubMessage = useCallback(
    (message: string, _payload: unknown) => {
      if (!shouldReport || !INTERACTION_MARKERS.has(message)) {
        return;
      }

      void postRequest('/v2/kyc/report/interaction').catch();
    },
    [shouldReport],
  );

  return { handleSumSubMessage };
}
